import React, { useState } from 'react';
import history from '../Routes/history';
import * as EmailValidator from "email-validator";
import { faUser, faEye, faEyeSlash, faEnvelope, faLock } from '@fortawesome/free-solid-svg-icons';
import '../../Styles/LoginPage/Login.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from "react-router-dom";
import { Image } from 'cloudinary-react';

function LoginForm() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const user = JSON.parse(localStorage.getItem('user'));

  function handleSubmit() {
    if (EmailValidator.validate(email)) {
      fetch('/api/login/auth', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ email, password }),
      })
        .then(async (res) => {
          if (res.status === 403 || res.status === 401) {
            setErrorMessage(await res.text());
          }
          if (res.status === 200) return res.json();
        })
        .then((res) => {
          if (res && res.access_token) {
            localStorage.setItem('user', JSON.stringify(res));
            history.push('/dashboard');
          }
        })
        .catch(err => console.log(err));
    } else {
      setErrorMessage('Votre adresse mail est invalide');
    }
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') handleSubmit();
  }

  function logout() {
    localStorage.removeItem('user');
  }

  function showPicture(u) {
    if (u.image === '') {
      return (
        <div className="lf-avatar lf-avatar--icon">
          <FontAwesomeIcon icon={faUser} />
        </div>
      );
    }
    return (
      <div className="lf-avatar">
        <Image className="lf-avatar__img" cloudName="ericguillet" publicId={u.image} crop="scale" />
      </div>
    );
  }

  if (user) {
    return (
      <div className="lf-root">
        <div className="lf-connected">
          {showPicture(user)}
          <p className="lf-connected__name">{user.lname} {user.fname}</p>
          <p className="lf-connected__hint">Vous êtes déjà connecté</p>
          <div className="lf-connected__actions">
            <Link to="/dashboard" className="lf-btn lf-btn--primary">Accéder au Dashboard</Link>
            <Link to="/login" className="lf-btn lf-btn--ghost" onClick={logout}>Se déconnecter</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="lf-root">
      <div className="lf-form">

        <div className="lf-field">
          <label htmlFor="email" className="lf-field__label">Adresse e-mail</label>
          <div className="lf-field__wrap">
            <span className="lf-field__icon" aria-hidden="true"><FontAwesomeIcon icon={faEnvelope} /></span>
            <input
              type="text"
              className="lf-field__input"
              id="email"
              name="email"
              placeholder="votre@email.com"
              autoComplete="email"
              onChange={e => setEmail(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </div>
        </div>

        <div className="lf-field">
          <label htmlFor="password" className="lf-field__label">Mot de passe</label>
          <div className="lf-field__wrap">
            <span className="lf-field__icon" aria-hidden="true"><FontAwesomeIcon icon={faLock} /></span>
            <input
              type={showPass ? 'text' : 'password'}
              className="lf-field__input lf-field__input--pwd"
              id="password"
              name="password"
              placeholder="••••••••"
              autoComplete="current-password"
              onChange={e => setPassword(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <button
              type="button"
              className="lf-field__toggle"
              onClick={() => setShowPass(s => !s)}
              aria-label={showPass ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
            >
              <FontAwesomeIcon icon={showPass ? faEyeSlash : faEye} />
            </button>
          </div>
        </div>

        <div className="lf-links">
          <Link to="/forgotpass" className="lf-links__item">Mot de passe oublié ?</Link>
          <Link to="/register" className="lf-links__item lf-links__item--register">S'inscrire</Link>
        </div>

        <button type="button" className="lf-submit" onClick={handleSubmit}>
          Se connecter
        </button>

        {errorMessage && <div className="lf-error" role="alert">{errorMessage}</div>}
      </div>
    </div>
  );
}

export default LoginForm;
